import { Fragment, useState } from 'react'; //, useContext, useEffect 
import type { IContact } from '../interfaces/IContact';
import {
    Box, Typography, FormControl, InputLabel, Select,
    MenuItem, Button, Table, TableHead, TableRow, TableCell, TableBody, Alert
} from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';
import '../css/displayregistrations.scss';
import '../css/fiche.scss';

interface ICourse {
    shortName: string;
    name: string;
    day: IDay;
    isVisible: boolean;
    startTime: string;
    endTime: string;
}

interface IStage {
    shortName: string;
    name: string;
    description: string;
    startDate: string;
    endDate: string;
    startTime: string;
    endTime: string;
}

interface IDay {
    name: string;
}

interface ICourseObj {
    course: ICourse;
    subscribes: IContact[];
}

interface IProps {
    courses: undefined | ICourseObj[];
    stages: undefined | IStage[];
    title: string;
}

const niceDate = (date: string) => {
    if (date === null)
        return '';
    const start = new Date(date);
    return `${start.getDate()}/${start.getMonth() + 1}/${start.getFullYear()}`;
};


const niceTime = (time: string) => {
    if (time === null)
        return '';
    const tokens = time.split(':');
    return `${tokens[0]}h${tokens[1]}`;
};

const monthToString = (month: number) => {
    const monthList = ['Janvier', 'Février', 'Mars',
        'Avril', 'Mai', 'Juin',
        'Juillet', 'Août', 'Septembre',
        'Octobre', 'Novembre', 'Décembre'];
    return monthList[month];
};
const nicePeriod = (startDate: string, endDate: string) => {
    if (startDate === null)
        return '';
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start.getMonth() === end.getMonth() && start.getDate() < end.getDate()) {
        return `${start.getDate()} au ${end.getDate()} ${monthToString(start.getMonth())}`;
    }
    return '';
};

const emptyCourseList: ICourseObj[] = [];

const DisplayRegistrations = ({ stages, courses, title }: IProps) => {
    const [course, setCourse] = useState("");
    const [stage, setStage] = useState("Choisir votre stage");
    const [currentCourse, setCurrentCourse] = useState(emptyCourseList);

    const print = () => window.print();

    const updateCourse = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;
        setCourse(value);
        const filtered = courses?.filter((c) => c.course.shortName === value);
        setCurrentCourse(filtered !== undefined ? filtered : emptyCourseList);
    };

    const updateStage = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;
        setStage(value);
    };


    return (
        <Box
            id="display-registrations"
            component="form"
            className="registration-form content-width"
            method="post">

            <Typography
                variant="h2"
            // sx={{ mb: 2, fontSize: '2rem' }}
            >
                Consulter les inscriptions pour le cours ci-dessous :
            </Typography>

            <Box className="registration-form-course">
                {courses !== undefined ? (
                    <Box>
                        <Box id="liste-registration" sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
                            {/* Sélecteur de cours */}
                            <FormControl size="small" sx={{ minWidth: 280 }}>
                                <InputLabel id="course-label">Cours</InputLabel>
                                <Select
                                    labelId="course-label"
                                    id="course"
                                    name="course"
                                    value={course ?? ''}        // valeur contrôlée
                                    label="Cours"
                                    onChange={updateCourse}     // (event) => ...
                                >
                                    <MenuItem key="default" value="">
                                        {title}
                                    </MenuItem>

                                    {courses
                                        .filter((li) => li.course.isVisible)
                                        .map((li) => {
                                            const schedule =
                                                li.course.day?.name !== ''
                                                    ? ` (${li.course.day?.name} de ${niceTime(li.course.startTime)} à ${niceTime(li.course.endTime)})`
                                                    : '';
                                            return (
                                                <MenuItem key={li.course.shortName} value={li.course.shortName}>
                                                    {li.course.name}{schedule}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </FormControl>

                            {/* Bouton imprimer */}
                            <Button
                                id="print"
                                variant="outlined"
                                onClick={print}
                            >
                                Imprimer la fiche
                            </Button>
                        </Box>

                        {/* Liste des inscrits */}
                        <Box id="liste-inscrits" className="registration-subscribers">
                            {course !== undefined && course !== '' ? (
                                <Box id="liste-inscrits-cours" className="registration-subscribe">
                                    {currentCourse !== undefined && currentCourse.length > 0 ? (
                                        currentCourse.map((cc, _) => (
                                            <Box key={cc.course.shortName} sx={{ mb: 3 }}>
                                                {cc.subscribes.length > 0 ? (
                                                    <div id="fiches-container">
                                                        <Table id="fiches" sx={{ width: '100%' }}>
                                                            <TableHead>
                                                                <TableRow className="mauve"
                                                                    sx={{
                                                                        backgroundColor: '#800080',
                                                                        color: '#ffffff'
                                                                    }}>
                                                                    <TableCell component="td" colSpan={2}
                                                                        sx={{ color: '#ffffff' }}>
                                                                        {cc.course.shortName.toUpperCase().replaceAll('-', ' ')}
                                                                    </TableCell>
                                                                    <TableCell component="td" colSpan={3}
                                                                        sx={{ color: '#ffffff' }}>
                                                                        {cc.course.day?.name} {niceTime(cc.course.startTime)} - {niceTime(cc.course.endTime)}
                                                                    </TableCell>
                                                                    {Array.from({ length: 10 }).map((_, i) => (
                                                                        <TableCell component="td" key={i}
                                                                            sx={{ color: '#ffffff' }}></TableCell>
                                                                    ))}
                                                                    <TableCell colSpan={5}>
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                justifyContent: 'flex-end',
                                                                                width: '95%',
                                                                            }}
                                                                        >
                                                                            ANNEE 2026/2027
                                                                        </Box>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                             {/* empty line */}
                                                            <TableBody>
                                                                <TableRow>
                                                                    {Array.from({ length: 20 }).map((_, i) => (
                                                                        <TableCell key={i}>{'\u00A0'}</TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            </TableBody>
                                                            {Array.from({ length: 2 }).map((_, j) => ( // header répété
                                                                <Fragment key={j}>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            {/* Mets ici tes colonnes réelles */}
                                                                            <TableCell>NOM</TableCell>
                                                                            <TableCell>PRENOM</TableCell>
                                                                            {Array.from({ length: 18 }).map((_, i) => (
                                                                                <TableCell component="td" key={i}></TableCell>
                                                                            ))}
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    {/* tableau avec les inscrits */}
                                                                    <TableBody>
                                                                        {cc.subscribes.map((s, i) => (
                                                                            <TableRow key={i}>
                                                                                <TableCell component="th">{s.lastName.toUpperCase()}</TableCell>
                                                                                <TableCell component="th">{s.firstName.toUpperCase()}</TableCell>
                                                                                {Array.from({ length: 18 }).map((_, i) => (
                                                                                    <TableCell component="td" key={i}></TableCell>
                                                                                ))}
                                                                                {/* <TableCell>{s.email}</TableCell> */}
                                                                                {/* <TableCell>{s.phone}</TableCell> */}
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            {Array.from({ length: 20 }).map((_, i) => (
                                                                                <TableCell component="td" key={i}>{'\u00A0'}</TableCell>
                                                                            ))}
                                                                        </TableRow>
                                                                    </TableHead>
                                                                </Fragment>
                                                            ))}
                                                            <TableHead>
                                                                <TableRow className="mauve"
                                                                    sx={{
                                                                        backgroundColor: '#800080',
                                                                        color: '#ffffff'
                                                                    }}>
                                                                    <TableCell component="td" colSpan={2}
                                                                        sx={{ color: '#ffffff' }}>
                                                                        {cc.course.shortName.toUpperCase().replaceAll('-', ' ')}
                                                                    </TableCell>
                                                                    <TableCell component="td" colSpan={3}
                                                                        sx={{ color: '#ffffff' }}>
                                                                        {cc.course.day?.name} {niceTime(cc.course.startTime)} - {niceTime(cc.course.endTime)}
                                                                    </TableCell>
                                                                    {Array.from({ length: 10 }).map((_, i) => (
                                                                        <TableCell component="td" key={i}
                                                                            sx={{ color: '#ffffff' }}></TableCell>
                                                                    ))}
                                                                    <TableCell colSpan={5}>
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                justifyContent: 'flex-end',
                                                                                width: '95%',
                                                                            }}
                                                                        >
                                                                            ANNEE 2025/2026
                                                                        </Box>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            {/* empty line */}
                                                            <TableBody>
                                                                <TableRow>
                                                                    {Array.from({ length: 20 }).map((_, i) => (
                                                                        <TableCell key={i}>{'\u00A0'}</TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            </TableBody>
                                                            <TableHead>
                                                                <TableRow>
                                                                    {/* Mets ici tes colonnes réelles */}
                                                                    <TableCell>NOM</TableCell>
                                                                    <TableCell>PRENOM</TableCell>
                                                                    <TableCell className="pink">IMAG.</TableCell>
                                                                    <TableCell className="green">ASS.</TableCell>
                                                                    <TableCell className="dark-pink">PAY.</TableCell>
                                                                    <TableCell className="yellow">SOLD.</TableCell>
                                                                    <TableCell colSpan={2}>TEL 1</TableCell>
                                                                    <TableCell colSpan={2}>TEL 2</TableCell>
                                                                    <TableCell colSpan={10}>EMAIL</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            {/* tableau avec les inscrits */}
                                                            <TableBody>
                                                                {cc.subscribes.map((s, i) => {
                                                                    const pink = s?.student?.imageRight ? "pink" : "";
                                                                    const green = s?.student?.insurance ? "green" : "";
                                                                    const darkpink = s?.student?.payment ? "dark-pink" : "";
                                                                    const yellow = s?.student?.hasRemainingSold ? "yellow" : "";
                                                                    return (
                                                                        <TableRow key={i}>
                                                                            <TableCell component="th">{s.lastName.toUpperCase()}</TableCell>
                                                                            <TableCell component="th">{s.firstName.toUpperCase()}</TableCell>
                                                                            <TableCell className={pink}></TableCell>
                                                                            <TableCell className={green}></TableCell>
                                                                            <TableCell className={darkpink}></TableCell>
                                                                            <TableCell className={yellow}></TableCell>
                                                                            <TableCell colSpan={2}>{s.phoneNumber}</TableCell>
                                                                            <TableCell colSpan={2}>{s.phoneNumber !== s.phoneNumber2 ? s.phoneNumber2 : s.phoneNumber3 !== s.phoneNumber ? s.phoneNumber3 : ''}</TableCell>
                                                                            <TableCell colSpan={10}>{s.email}</TableCell>
                                                                        </TableRow>
                                                                    )
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                        <Table id="full" sx={{ width: '100%' }}>
                                                            <TableHead>
                                                                <TableRow className="bleu-vert"
                                                                    sx={{
                                                                        backgroundColor: 'rgba(0,128,128,1)',
                                                                        color: '#ffffff'
                                                                    }}>
                                                                    <TableCell component="td"></TableCell>
                                                                    <TableCell component="td"></TableCell>
                                                                    <TableCell component="td">{cc.subscribes.length}</TableCell>
                                                                    <TableCell component="td">ELEVES</TableCell>
                                                                    <TableCell component="td" colSpan={4}>Mise à jour : 17/02/2026</TableCell>
                                                                    {Array.from({ length: 10 }).map((_, i) => (
                                                                        <TableCell component="td" key={i}
                                                                            sx={{ color: '#ffffff' }}></TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableHead>
                                                                <TableRow>
                                                                    {/* Mets ici tes colonnes réelles */}
                                                                    <TableCell>Mise à jour</TableCell>
                                                                    <TableCell></TableCell>
                                                                    <TableCell>N°</TableCell>
                                                                    <TableCell>NOM</TableCell>
                                                                    <TableCell>PRENOM</TableCell>
                                                                    <TableCell className="bleu-vert">INSCR.</TableCell>
                                                                    <TableCell className="bleu-vert">CONN</TableCell>
                                                                    <TableCell className="pink">IMAG.</TableCell>
                                                                    <TableCell className="green">ASS.</TableCell>
                                                                    <TableCell className="dark-pink">PAY.</TableCell>
                                                                    <TableCell className="yellow">SOLD.</TableCell>
                                                                    <TableCell>ADRESSE</TableCell>
                                                                    <TableCell>TEL 1</TableCell>
                                                                    <TableCell>TEL 2</TableCell>
                                                                    <TableCell>TEL 3</TableCell>
                                                                    <TableCell>EMAIL 1</TableCell>
                                                                    <TableCell>EMAIL 2</TableCell>
                                                                    <TableCell>D.N. </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            {/* tableau avec les inscrits */}
                                                            <TableBody>
                                                                {cc.subscribes.map((s, i) => {
                                                                    const pink = s?.student?.imageRight ? "pink" : "";
                                                                    const green = s?.student?.insurance ? "green" : "";
                                                                    const darkpink = s?.student?.payment ? "dark-pink" : "";
                                                                    const yellow = s?.student?.hasRemainingSold ? "yellow" : "";
                                                                    return (
                                                                        <TableRow key={i}>
                                                                            <TableCell>{niceDate(s.dateModification)}</TableCell>
                                                                            <TableCell></TableCell>
                                                                            <TableCell>{s.contactId}</TableCell>
                                                                            <TableCell>{s.lastName}</TableCell>
                                                                            <TableCell>{s.firstName}</TableCell>
                                                                            <TableCell className="bleuvert"></TableCell>
                                                                            <TableCell></TableCell>
                                                                            <TableCell className={pink}></TableCell>
                                                                            <TableCell className={green}></TableCell>
                                                                            <TableCell className={darkpink}></TableCell>
                                                                            <TableCell className={yellow}></TableCell>
                                                                            <TableCell>{s.address}</TableCell>
                                                                            <TableCell>{s.phoneNumber}</TableCell>
                                                                            <TableCell>{s.phoneNumber2}</TableCell>
                                                                            <TableCell>{s.phoneNumber3}</TableCell>
                                                                            <TableCell>{s.email ? s.email : s.email1}</TableCell>
                                                                            <TableCell>{(s.email && s.email1 != s.email) ? s.email1 : (s.email2 != s.email1 && s.email2 !== s.email ? s.email2 : '')}</TableCell>
                                                                            <TableCell>{niceDate(s.birthdate)}</TableCell>
                                                                        </TableRow>
                                                                    )
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                    </div>
                                                ) : (
                                                    <Alert severity="info">
                                                        Il n&apos;y a pour l&apos;instant aucun élève inscrits à ce cours
                                                    </Alert>
                                                )}
                                            </Box>
                                        ))
                                    ) : (
                                        <Alert severity="warning">
                                            Aucun cours correspondant au choix n&apos;a été trouvé
                                        </Alert>
                                    )}
                                </Box>
                            ) : (
                                <Alert severity="error">Veuillez choisir un cours</Alert>
                            )}
                        </Box>
                    </Box>
                ) : (
                    <Box />
                )}

                {/* Sélecteur de stages */}
                {stages !== undefined ? (
                    <FormControl size="small" sx={{ minWidth: 280, mt: 3 }}>
                        <InputLabel id="stage-label">Stage</InputLabel>
                        <Select
                            labelId="stage-label"
                            id="stage"
                            name="stage"
                            value={stage ?? ''}
                            label="Stage"
                            onChange={updateStage}
                        >
                            <MenuItem key="default" value="">
                                {title}
                            </MenuItem>
                            {stages.map((li) => {
                                const schedule =
                                    li.startDate !== undefined ? ` (Du ${nicePeriod(li.startDate, li.endDate)})` : '';
                                return (
                                    <MenuItem key={li.shortName} value={li.shortName}>
                                        {li.description}{schedule}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                ) : (
                    <Box />
                )}
            </Box>

        </Box>
    )
}

export default DisplayRegistrations;

// import { Form } from 'reactstrap'; // ,Label,  Input, Button
// à ${start.getHours()}h${start.getMinutes()}

//const context = useContext(GlobalContext);
//const registerDispatch = context?.registerDispatch;

// const [error, setError] = useState(undefined);
// useEffect(() => {
// });
// console.log("course: ", course);
// console.log("stage: ", stage);


// const updateCourse: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
//     setCourse(e.target.value);
//     const filtered = courses?.filter((c) => c.course.shortName === e.target.value);
//     console.log('current course', currentCourse);
//     setCurrentCourse(filtered !== undefined ? filtered : emptyCourseList);
//     // setForm({ ...form, [e.target.id]: e.target.value });
// };


// const updateStage: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
//     setStage(e.target.value);
//     // setForm({ ...form, [e.target.id]: e.target.value });
// };
// setForm({ ...form, [event.target.name]: value }); // si besoin




        //         <Form className="registration-form content-width" method="post">
        //             <h2>Consulter les inscriptions pour le cours ci-dessous : </h2>
        //             <div className="registration-form-course" >
        //             {courses !== undefined ?
        //             <div>
        //                 <div className="flex">
        //                     <select name="course" id="course" value={course} onChange={updateCourse}>
        //                     <option key='default' value=''>{title}</option>
        //                     {
        //                         courses.filter((li) => li.course.isVisible).map((li) =>{
        //                             const schedule = li.course.day?.name !== '' ? ` (${li.course.day?.name} de ${niceTime(li.course.startTime)} à ${niceTime(li.course.endTime)})`  : '';
        //                             return (
        //                                 <option key={li.course.shortName} value={li.course.shortName}>{li.course.name}{schedule}</option>
        //                             );
        //                         })
        //                     }
        //                     </select>
        //                     <input id="print" type="button" value="Imprimer la fiche" onClick={print} />
        //                 </div>
        //                 <div className="registration-subscribers">
        //                     {course !== undefined && course !== '' ?
        //                         <div className="registration-subscribe">
        //                             {/* <p>Cours choisi: {course}</p> */}
        //                             {currentCourse !== undefined && currentCourse.length > 0 ? 
        //                                 currentCourse.map((cc) => (
        //                                     <div>
        //                                         {
        //                                             cc.subscribes.length > 0 ?
        //                                             <div>
        //                                                 <table id="fiches" style={{width: "100%"}}>
        //                                                     <thead>
        //                                                     <tr className="mauve">
        //                                                             <td colSpan={2}>{cc.course.shortName.toUpperCase().replaceAll('-',' ')}</td>
        //                                                             <td colSpan={3}>{cc.course.day?.name} {niceTime(cc.course.startTime)} - {niceTime(cc.course.endTime)}
        //                                                             {/* const schedule = li.startDate !== undefined ? ` (Du ${nicePeriod(li.startDate,li.endDate)})`  : ''; */}
        //                         {/* return ( */}
        //                             {/* <option key={li.shortName} value={li.shortName}>{li.description}{schedule}</option> */}
        //                         {/* ); */}


        //                                                                 </td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td colSpan={5} className="align-right">ANNEE 2025/2026</td>
        //                                                         </tr>
        //                                                     </thead>
        //                                                     <tbody>
        //                                                         <tr><td><br /></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td></tr>
        //                                                     </tbody>
        //                                                 <thead>
        //                                                         <tr>
        //                                                             <th>NOM</th>
        //                                                             <th>PRENOM</th>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                         </tr>
        //                                                     </thead>
        //                                                     <tbody>
        //                                                         {cc.subscribes.map((contact) => (
        //                                                         <tr>
        //                                                             <th>{contact.lastName.toUpperCase()}</th>
        //                                                             <th>{contact.firstName.toUpperCase()}</th>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                         </tr>
        //                                                 ))}
        //                                                     </tbody>
        //                                                     <tbody>
        //                                                         <tr><td><br /></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td></tr>
        //                                                     </tbody>
        //                                                     <thead>
        //                                                         <tr>
        //                                                             <th>NOM</th>
        //                                                             <th>PRENOM</th>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                         </tr>
        //                                                     </thead>
        //                                                     <tbody>
        //                                                         {cc.subscribes.map((contact) => (
        //                                                         <tr>
        //                                                             <th>{contact.lastName.toUpperCase()}</th>
        //                                                             <th>{contact.firstName.toUpperCase()}</th>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                         </tr>
        //                                                 ))}

        //                                                     </tbody>

        //                                                     <tbody>
        //                                                         <tr><td><br /></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td></tr>
        //                                                     </tbody>
        //                                                     <thead>
        //                                                         <tr className="mauve">
        //                                                             <td colSpan={2}>{cc.course.shortName.toUpperCase().replaceAll('-',' ')}</td>
        //                                                             <td colSpan={3}>{cc.course.day?.name} {niceTime(cc.course.startTime)} - {niceTime(cc.course.endTime)}
        //                                                             {/* const schedule = li.startDate !== undefined ? ` (Du ${nicePeriod(li.startDate,li.endDate)})`  : ''; */}
        //                         {/* return ( */}
        //                             {/* <option key={li.shortName} value={li.shortName}>{li.description}{schedule}</option> */}
        //                         {/* ); */}


        //                                                                 </td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td colSpan={5} className="align-right">ANNEE 2025/2026</td>
        //                                                         </tr>
        //                                                     </thead>
        //                                                     <tbody>
        //                                                         <tr><td><br /></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td></tr>
        //                                                     </tbody>
        //                                                     <thead>
        //                                                     <tr>
        //                                                             <th>NOM</th>
        //                                                             <th>PRENOM</th>
        //                                                             <th className="pink">IMAG.</th>
        //                                                             <th className="green">ASS.</th>
        //                                                             <th className="dark-pink">PAY.</th>
        //                                                             <th className="yellow">SOLD.</th>
        //                                                             <th colSpan={2}>TEL 1</th>
        //                                                             <th colSpan={2}>TEL 2</th>
        //                                                             <th colSpan={10}>EMAIL</th>
        //                                                         </tr>
        //                                                     </thead>
        //                                                     <tbody>
        //                                                         {cc.subscribes.map((contact) => {
        //                                                             const pink = contact?.student?.imageRight ? "pink" : "";
        //                                                             const green = contact?.student?.insurance ? "green" : "";
        //                                                             const darkpink = contact?.student?.payment ? "dark-pink" : "";
        //                                                             const yellow = contact?.student?.hasRemainingSold ? "yellow" : "";
        //                                                             return (
        //                                                         <tr>
        //                                                             <th>{contact.lastName.toUpperCase()}</th>
        //                                                             <th>{contact.firstName.toUpperCase()}</th>
        //                                                             <td className={pink}></td>
        //                                                             <td className={green}></td>
        //                                                             <td className={darkpink}></td>
        //                                                             <td className={yellow}></td>
        //                                                             <td colSpan={2}>{contact.phoneNumber}</td>
        //                                                             <td colSpan={2}>{contact.phoneNumber !== contact.phoneNumber2 ? contact.phoneNumber2 : ''}</td>
        //                                                             <td colSpan={10}>{contact.email}</td>
        //                                                         </tr>

        // /*
        //                                                             <td>{contact.phoneNumber}</td>
        //                                                             <td>{contact.phoneNumber !== contact.phoneNumber2 ? contact.phoneNumber2 : ''}</td>
        //                                                             <td>{(contact.phoneNumber !== contact.phoneNumber3 && contact.phoneNumber2 !== contact.phoneNumber3)  ? contact.phoneNumber3 : ''}</td>
        //                                                             <td>{contact.email ? contact.email : contact.email1}</td>
        //                                                             <td>{contact.email2}</td>
        //  */

        //                                                 )}
        //                                                 )}

        //                                                     </tbody>
        //                                                 </table>
        //                                                 <table id="full" style={{width: "100%"}}>
        //                                                     <thead>
        //                                                         <tr className="bleu-vert">
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td>{cc.subscribes.length}</td>
        //                                                             <td>ELEVES</td>
        //                                                             <td>màj 28/07/2025</td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                             <td></td>
        //                                                         </tr>
        //                                                         <tr>
        //                                                             <th>Mise à jour</th>
        //                                                             <th></th>
        //                                                             <th>N°</th>
        //                                                             <th>NOM</th>
        //                                                             <th>PRENOM</th>
        //                                                             <th className="bleu-vert">INSCR.</th>
        //                                                             <th className="bleu-vert">CONN</th>
        //                                                             <th className="pink">IMAG.</th>
        //                                                             <th className="green">ASS.</th>
        //                                                             <th className="dark-pink">PAY.</th>
        //                                                             <th className="yellow">SOLD.</th>
        //                                                             <th>ADRESSE</th>
        //                                                             <th>TEL 1</th>
        //                                                             <th>TEL 2</th>
        //                                                             <th>TEL 3</th>
        //                                                             <th>EMAIL 1</th>
        //                                                             <th>EMAIL 2</th>
        //                                                             <th>D.N</th>
        //                                                         </tr>
        //                                                     </thead>
        //                                                     <tbody>
        //                                                         {cc.subscribes.map((contact) => {
        //                                                             const pink = contact?.student?.imageRight ? "pink" : "";
        //                                                             const green = contact?.student?.insurance ? "green" : "";
        //                                                             const darkpink = contact?.student?.payment ? "dark-pink" : "";
        //                                                             const yellow = contact?.student?.hasRemainingSold ? "yellow" : "";
        //                                                             return (
        //                                                         <tr>
        //                                                             <td>{niceDate(contact.dateModification)}</td>
        //                                                             <td></td>
        //                                                             <td>{contact.contactId}</td>
        //                                                             <td>{contact.lastName}</td>
        //                                                             <td>{contact.firstName}</td>
        //                                                             <td className="bleu-vert"></td>
        //                                                             <td></td>
        //                                                             <td className={pink}></td>
        //                                                             <td className={green}></td>
        //                                                             <td className={darkpink}></td>
        //                                                             <td className={yellow}></td>
        //                                                             <td>{contact.address}</td>
        //                                                             <td>{contact.phoneNumber}</td>
        //                                                             <td>{contact.phoneNumber !== contact.phoneNumber2 ? contact.phoneNumber2 : ''}</td>
        //                                                             <td>{(contact.phoneNumber !== contact.phoneNumber3 && contact.phoneNumber2 !== contact.phoneNumber3)  ? contact.phoneNumber3 : ''}</td>
        //                                                             <td>{contact.email ? contact.email : contact.email1}</td>
        //                                                             <td>{(contact.email && contact.email1 !== contact.email) ? contact.email1 : (contact.email2 !== contact.email1 && contact.email2 !== contact.email ? contact.email2 : '')}</td>
        //                                                             <td>{niceDate(contact.birthdate)}</td>
        //                                                         </tr>
        //                                                 )}
        //                                                 )}

        //                                                     </tbody>
        //                                                 </table>

        //                                             {/* <p>Nombre d'inscrits : {cc.subscribes.length}</p>
        //                                             <ul>{cc.subscribes.map((contact) => (
        //                                                 <li>{contact.firstName} {contact.lastName}</li>                                        
        //                                             ))}</ul> */}
        //                                             </div>
        //                                             :
        //                                             <p>Il n'y a pour l'instant aucun élève inscrits à ce cours</p>
        //                                         }
        //                                     </div>
        //                                 ))
        //                                 :
        //                                 <p>Aucun cours correspondant au choix n'a été trouvé</p>
        //                         }
        //                         </div>
        //                         : <p className="error">Veuillez choisir un cours</p>}
        //                 </div>
        //             </div>
        //         : <div/>
        //             }
        //                 {stages !== undefined ?
        //                 <select name="stage" id="stage" value={stage} onChange={updateStage}>
        //                 <option key='default' value=''>{title}</option>
        //                 {
        //                     stages.map((li) =>{
        //                         const schedule = li.startDate !== undefined ? ` (Du ${nicePeriod(li.startDate,li.endDate)})`  : '';
        //                         return (
        //                             <option key={li.shortName} value={li.shortName}>{li.description}{schedule}</option>
        //                         );
        //                     })
        //                 }
        //             </select>
        //             : <div/>
        //             }

        //             </div>
        //         </Form>